export default __webpack_public_path__ + "static/media/rounded-checked.41a71ca8.svg";